<template src="./template.html"></template>

<script>
export default {
  name: "NewsListTopCover",
  data() {
    return {}
  }
}
</script>